<template>
  <div id="homeAddress">
	<plugin />
	<myAddress  @changeFN="changeAddressFN" />
	
  </div>
</template>

<script>

import myAddress from '@/components/myAddress.vue'
import plugin from '@/components/plugin.vue'
export default {
  name: 'homeAddress',
  components: {
	plugin,
	myAddress
  },
  data() {
      return {
	   
      }
    },
    computed: {
     
    },
    mounted() {
     
     
    },
    methods:{	
		changeAddressFN(){
			this.myAddressShow = false
		}	
    }
}
</script>
<style>
#homeAddress{
  background:rgba(244,242,240,1);
  width: 7.5rem;
  height: 100vh;
  position:relative;
  margin: 0 auto;
  background-color: #fff;
  
  
}
#homeAddress::-webkit-scrollbar {display:none}


</style>